import React from "react";
import dummyLawyer from "../../assets/images/dummyLawyer.jpeg";
import { isBlankFile } from "../../services/userApi";

const money = (v) => Number((Number(v) || 0).toFixed(2)).toLocaleString();

// "Tax Law +21" — first name plus how many more.
const firstPlus = (list = []) => {
  const names = list.map((x) => x?.name).filter(Boolean);
  if (!names.length) return "";
  return names.length > 1 ? `${names[0]} +${names.length - 1}` : names[0];
};

export const lawyerTitle = (l) => l?.company_name || l?.name || "";

// Expert card as on the app home: cover image, name, rating, country, practice
// areas, jurisdictions and the one-time / monthly service prices.
const LawyerCard = ({ lawyer }) => {
  const cover = (lawyer.images || []).find((src) => !isBlankFile(src)) || (!isBlankFile(lawyer.picture) && lawyer.picture) || dummyLawyer;
  const categories = firstPlus(lawyer.categories);
  const jurisdictions = firstPlus(lawyer.jurisdictions);
  const rating = Number(lawyer.rating) || 0;

  return (
    <article className="usp-lawyer">
      <div className="usp-lawyer-cover">
        <img src={cover} alt={lawyerTitle(lawyer)} loading="lazy" onError={(e) => (e.currentTarget.src = dummyLawyer)} />
      </div>
      <div className="usp-lawyer-body">
        <h4>{lawyerTitle(lawyer)}</h4>
        <p className="usp-lawyer-meta">
          <span className="usp-lawyer-rating">
            {rating || "New"} <i className="bi bi-star-fill" />
          </span>
          {lawyer.country && <span>{lawyer.country}</span>}
        </p>
        {categories && <p className="usp-lawyer-tag">{categories}</p>}
        {jurisdictions && (
          <p className="usp-lawyer-tag">
            Jurisdiction: <span>{jurisdictions}</span>
          </p>
        )}
        <div className="usp-lawyer-price">
          <span>
            $ {money(lawyer.weekly_price)}<small>/ One Time Service</small>
          </span>
          <span>
            $ {money(lawyer.monthly_price || (Number(lawyer.weekly_price) || 0) * 4)}<small>/ Monthly</small>
          </span>
        </div>
      </div>
    </article>
  );
};

export const LawyerCardSkeleton = () => (
  <article className="usp-lawyer" aria-hidden="true">
    <div className="usp-lawyer-cover lwp-skel" />
    <div className="usp-lawyer-body">
      <span className="lwp-skel lwp-skel-line" />
      <span className="lwp-skel lwp-skel-line short" />
      <span className="lwp-skel lwp-skel-line" />
    </div>
  </article>
);

export default LawyerCard;
